import { PER_PAGE_COUNT } from '~scenes/madeforyou/constants';

export const selectActiveTab = (state) => state.mfyData.activeTab;
export const selectIsMadeForYouWidget = (state) => state.mfyData.isMadeForYouWidget;
export const selectTabList = (state) => state.mfyData.tabList;
export const selectTabIsLoading = (activeTab) => (state) => Boolean(state.mfyData.isLoading[activeTab]);
export const selectCurrentPage = (state) => state.mfyData.currentPage;
export const selectBetCards = (state) => state.mfyData.betCards;
export const selectBetCardsByPage = (page) => (state) => {
    const betCards = selectBetCards(state);

    return betCards.slice((page - 1) * PER_PAGE_COUNT, page * PER_PAGE_COUNT);
};
export const selectVisibleBetCardSelectionIds = (state) => {
    const currentPage = selectCurrentPage(state);
    const betcards = selectBetCardsByPage(currentPage)(state);

    return betcards.reduce((acc, betcard) => [...acc, betcard.betcard_id], []);
};
export const selectCommonDataEvents = (state) => state.commonData;
